import { GameType } from "domain/models/types";

export enum LeaderBoardType {
  BASIC,
  ADVANCED,
  EXPERT,
  GENIUS,
}

export const leaderBoardTypes: LeaderBoardType[] = [
  LeaderBoardType.BASIC,
  LeaderBoardType.ADVANCED,
  LeaderBoardType.EXPERT,
  LeaderBoardType.GENIUS,
];

export const getGameTypeFromLeaderBoardtype: (
  leaderBoardType: LeaderBoardType
) => GameType = (leaderBoardType: LeaderBoardType) => {
  switch (leaderBoardType) {
    case LeaderBoardType.BASIC:
      return "Basic";
    case LeaderBoardType.ADVANCED:
      return "Advanced";
    case LeaderBoardType.EXPERT:
      return "Expert";
    case LeaderBoardType.GENIUS:
      return "Genius";
  }
};

export const translationKeyForLeaderBoard = (type: LeaderBoardType) => {
  switch (type) {
    case LeaderBoardType.BASIC:
      return "leaderBoardType.basic";
    case LeaderBoardType.ADVANCED:
      return "leaderBoardType.advanced";
    case LeaderBoardType.EXPERT:
      return "leaderBoardType.expert";
    case LeaderBoardType.GENIUS:
      return "leaderBoardType.genius";
  }
};
